import { render, staticRenderFns } from "./AiSearchKeyWord.vue?vue&type=template&id=e027454a&scoped=true&"
import script from "./AiSearchKeyWord.vue?vue&type=script&lang=js&"
export * from "./AiSearchKeyWord.vue?vue&type=script&lang=js&"
import style0 from "./AiSearchKeyWord.vue?vue&type=style&index=0&id=e027454a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e027454a",
  null
  
)

export default component.exports